module.exports = __webpack_public_path__ + "img/layers.2bdc4613.svg";